import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=ecb5f042&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecb5f042')) {
      api.createRecord('ecb5f042', component.options)
    } else {
      api.reload('ecb5f042', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=ecb5f042&", function () {
      api.rerender('ecb5f042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/usergroup/Edit.vue"
export default component.exports